export enum PoolerEmploymentTabIdEnum {
  NEW = 'NEW',
  ANSWERED = 'ANSWERED',
  BOOKED = 'BOOKED',
  ARCHIVED = 'ARCHIVED',
}
